"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arraySum = void 0;
function arraySum(arr) {
    return arr.reduce(function (acc, currVal) { return acc + currVal; }, 0);
}
exports.arraySum = arraySum;
